// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-view__wrapper","button":"error-view__button","copy":"error-view__copy"};